import { render, staticRenderFns } from "./TableBlueInvoiceHistory.vue?vue&type=template&id=2f017bbd&"
import script from "./TableBlueInvoiceHistory.vue?vue&type=script&lang=js&"
export * from "./TableBlueInvoiceHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports